import Modal from "~/components/Modal";

import "./style.less";
import { trans } from "~/utils/trans";

interface IDonationModal {
	onClose?: () => void;
}

export default function DonationModal({
	onClose = () => {},
}: IDonationModal) {
	return <Modal onClose={onClose} className="donation-modal">
		<div className="donationModal__header">
			<h2>{trans("donation.title")}</h2>
		</div>
		<div className="donationModal__content">
			<p>{trans("donation.text")}</p>
			<div className="donation-methods">
				<div className="method-box">
					<a href="https://www.buymeacoffee.com/doitforyourself" target="_blank" rel="noreferrer">
						<img src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" alt="Buy Me a Coffee" className="buy-coffee" / >
					</a>
					<p>{trans("donation.card")}</p>
				</div>

				<div className="method-box">
					<img src="https://www.doitforyourself.cz/img/qr_kod.jpg" alt={trans("donation.qr")} className="qr-image" />
					<p>{trans("donation.qr")}</p>
					<p>{trans("donation.bank")} 2402117016/2010</p>
				</div>
			</div>
		</div>
	</Modal>;
}
